import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { HTMLTrans } from '../../Common/Translations';
import InputField from '../../Common/InputField';
import SocialMediaShareButtons from '../../Common/SocialMediaShareButtons';

const copyLink = ({ t }) => (
  toastr.success(
    `${t("ephotobook.ephotobook_copylink_successfully", "Copied!")}`, '',
      {"positionClass": "toast-bottom-full-width"}
  )
);

const EPhotobookPublicShareLink = ({ t, link, title, previewImg, isFullWidth = false, index = 'preview' }) => (
  <div className={isFullWidth ? 'col-lg-12' : 'col-lg-6'}>
    <label className="ProximaNova-Bold pb-2">
      <HTMLTrans id="ephotobook.ephotobook_public_share_link_title">Share link with anyone</HTMLTrans>
    </label>
    <CopyToClipboard
      text={link}
      onCopy={() => copyLink({ t })}>
      <div className="d-flex align-items-center mb-2">
          <InputField
            id={`ephotobook-public-link-${index}`}
            type='text'
            value={link}
            formClass='form-group col p-0 mb-0'
            labelClass='form-control-label'
            readOnly={true}
          />
        <p className="pl-2 m-0 copy-link-text">
          <HTMLTrans id="ephotobook.ephotobook_copy_link">Copy Link</HTMLTrans>
        </p>
      </div>
    </CopyToClipboard>
    <SocialMediaShareButtons link={link} title={title} previewImg={previewImg}/>
  </div>
);

export default EPhotobookPublicShareLink;


// WEBPACK FOOTER //
// ./src/Account/EPhotobook/EPhotobookPublicShareLink.js